import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { useOrders } from "@/lib/OrdersContext";
import { PageHeader, DataTable } from "@/components/PageHeader";
import { eur, shortId } from "@/lib/workshop";

const HEAD = ["Orden", "Entrada", "Matrícula", "Vehículo", "Cliente", "Trabajo", "Importe", "Pago"];
const fmt = (d) => (d ? new Date(d).toLocaleDateString("es-ES") : "—");

const Row = ({ o, onPago }) => (
  <tr data-testid={`delivered-row-${o.id}`} className="border-b border-white/5 transition-colors hover:bg-white/[0.02]">
    <td className="px-5 py-3 text-zinc-500">#{shortId(o.id)}</td>
    <td className="px-5 py-3 text-zinc-400">{fmt(o.createdAt)}</td>
    <td className="px-5 py-3 font-mono-plate text-xs">{o.matricula || "—"}</td>
    <td className="px-5 py-3 font-semibold">{o.modelo || "—"}</td>
    <td className="px-5 py-3 text-zinc-400">{o.cliente || "—"}</td>
    <td className="max-w-[240px] truncate px-5 py-3 text-zinc-400">{o.servicio}</td>
    <td className="px-5 py-3 font-semibold">{eur(o.importe)}</td>
    <td className="px-5 py-3">
      <button data-testid={`delivered-payment-toggle-${o.id}`} onClick={() => onPago(o.id)}
        className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${o.pagado ? "bg-emerald-500/15 text-emerald-400" : "bg-[var(--gold-soft)] text-[var(--gold)]"}`}>
        {o.pagado ? "Pagado" : "Pendiente"}
      </button>
    </td>
  </tr>
);

export default function HistorialPage() {
  const { delivered, togglePago } = useOrders();
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return delivered;
    return delivered.filter((o) => [o.cliente, o.modelo, o.matricula, o.servicio, o.telefono].join(" ").toLowerCase().includes(s));
  }, [delivered, q]);

  return (
    <>
      <PageHeader title="Historial de Entregados" subtitle={`${delivered.length} órdenes finalizadas · ${eur(delivered.reduce((s, o) => s + o.importe, 0))}`} />
      <div className="relative mb-4 max-w-md">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
        <input data-testid="delivered-search-input" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar por cliente, matrícula, modelo…"
          className="h-10 w-full rounded-lg border border-white/10 bg-white/[0.03] pl-9 pr-3 text-sm outline-none transition-colors placeholder:text-zinc-500 focus:border-[var(--gold)]" />
      </div>
      <DataTable testid="delivered-table" head={HEAD} rows={list.map((o) => <Row key={o.id} o={o} onPago={togglePago} />)}
        empty={q ? "Ninguna orden entregada coincide con la búsqueda" : "Aún no hay órdenes entregadas"} />
    </>
  );
}
